
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buildings/borough/[borough]",
      function () {
        return require("private-next-pages/buildings/borough/[borough]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buildings/borough/[borough]"])
      });
    }
  